module.exports = __webpack_public_path__ + "media/assets/icons/carousel-second-b43577089a779a8a2d7d178e9d3c06c7.png";